import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import useAdd from "../../../../api/useAdd";
import { useTranslation } from "react-i18next";

const Type = ({ open, onClose, token, type }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
  });

  const { handleAdd, resetForm, loading } = useAdd("period", token);

  const {
    handleAdd: handelAddLab,
    resetForm: resetFormLab,
    loading: loadingLab,
  } = useAdd("lab", token);

  const {
    handleAdd: handleAddType,
    resetForm: resetFormType,
    loading: loadingType,
  } = useAdd("procedure-type", token);

  useEffect(() => {
    if (resetForm || resetFormType || resetFormLab) {
      setFormData({ name: "" });
      onClose();
    }
  }, [resetForm, resetFormType, resetFormLab]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (type === "type") {
      handleAddType(formData);
    } else if (type === "period") {
      handleAdd(formData);
    } else {
      handelAddLab(formData);
    }
  };
  return (
    <Grid container>
      <Dialog
        open={open}
        onClose={onClose}
        component={"form"}
        onSubmit={handleSubmit}
      >
        <DialogTitle>
          {(type === "type" && t("call_center.addNewType")) ||
            (type === "period" && t("call_center.addNewPeriod")) ||
            (type === "lab" && t("call_center.addNewLab"))}
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label={
              (type === "type" && t("call_center.addNewType")) ||
              (type === "period" && t("call_center.addNewPeriod")) ||
              (type === "lab" && t("call_center.addNewLab"))
            }
            variant="standard"
            name="name"
            value={formData.name}
            onChange={(e) => {
              setFormData({ name: e.target.value });
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            sx={{ textTransform: "capitalize", margin: "0px 5px" }}
            onClick={onClose}
          >
            {t("call_center.cancel")}
          </Button>
          <Button
            variant="outlined"
            type="submit"
            sx={{ textTransform: "capitalize" }}
            disabled={loading || loadingType}
          >
            {loading || loadingType
              ? t("call_center.saving")
              : t("call_center.save")}
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default Type;
